import { graphql, ResultOf } from ':src/graphql';
import { useSuspenseQuery } from '@apollo/client';

export const viewerQuery = graphql(`
  query ViewerQuery {
    viewer {
      id
      firstName
      lastName
      fullName
      pendingEmail
      email
      phone
      mediumAvatar
      organizationId
      organizationPrograms {
        id
        name
      }
      scope
      organizationRoleId
      permissions {
        permissionNames
        programIds
      }
      organization {
        id
        name
        clinicalSettingId
        requiresNotesInReports
        requiresSupervisorAdminHours
        servesMedicaidClients
        requiresProgramOnSuperviseeUpload
        isEnterprise
        isMotivoBasic
        supervisionModelId
        usesBillingCodes
        hasAssignedEmployerCareManager
        supervisionAvailability
        introCallPreferenceId
        basicOnboardingCompletedAt
        basicInvitationsSentAt
        populations {
          id
          name
        }
        specialties {
          id
          name
        }
        organizationEmergencyContacts {
          id
          firstName
          lastName
          email
          phone
        }
        accountManagerAdmin {
          id
          firstName
          lastName
          fullName
          email
          title
          mediumAvatar
        }
      }
      featureFlags
      openIntroRequestsCount
      timezone
      canAccessBillableWork
      organizationPrograms {
        id
        name
      }
    }
  }
`);

type ViewerQueryQuery = ResultOf<typeof viewerQuery>;
type NonNullableOrganization = NonNullable<ViewerQueryQuery['viewer']['organization']>;

type ViewerWithOrganizationId = Omit<
  ViewerQueryQuery['viewer'],
  'organizationId' | 'organization'
> & {
  organizationId: number;
  organization: NonNullableOrganization;
};

export default function useViewer(options = {}) {
  const {
    data: { viewer },
    refetch,
  } = useSuspenseQuery(viewerQuery, options);

  return {
    viewer: viewer as ViewerWithOrganizationId,
    refetch,
    isLoggedIn: viewer.scope === 'organizationAdmin',
  };
}
